module.exports = __webpack_public_path__ + "static/media/cardIconModerationAdmin.37baed5a.svg";